import Cookies from "js-cookie";

$(document).on('turbo:load', function() {
  $(".global-suppressable-alert[data-name]").on("closed.bs.alert", e=> {
    const alerts = (Cookies.get('suppress_alerts') || "").split(",").filter(x => x.length);
    alerts.push($(e.target).attr("data-name"));
    Cookies.set('suppress_alerts', alerts.join(","), { expires: 300 });
  });

  // NOTE: using not(.react) because react handles it's own event clicks and state
  // and we don't want to interfere with that from outside of react context
  $(".alert.collapsable:not(.react) .toggle-content").on("click", e=> {
    e.preventDefault();
    const alert = $(e.currentTarget).closest(".alert");

    if (alert.hasClass("open")) {
      alert.removeClass("open");
      alert.find(".toggle-content a").text("See more");
    } else {
      alert.addClass("open");
      alert.find(".toggle-content a").text("See less");
    }
  });

  // Automatically show any flash messages
  setTimeout((() => $('.flash .alert-dismissible').slideUp()), 4000);

  // Automatically show subscription confirmation modals
  $(".subscription-confirmation-modal").modal("show");

  // Automatically show AI trial activated modal
  $(".ai-trial-activated-modal").modal("show");

  // Automatically show reactivate subscription confirmation modal
  $(".reactivate-subscription-confirmation-modal").modal("show");

  // Automatically show paywall modals
  $('#not-subscribed-modal').each(function(_i, el) {
    const modal = $(el);

    modal.on("hidden.bs.modal", () => modal.remove());
    modal.on('shown.bs.modal', () => {
      const event = new CustomEvent('loomly.modal.shown');
      document.dispatchEvent(event);
    });

    modal.modal({ show: true, backdrop: 'static', keyboard: false });
  });
});
